import { qtyProxy } from "../../../helpers/helper";


export function editCanvasInit(logoList = "", ) {
    qtyProxy["logoList"] = JSON.parse(logoList)
}